import { render, staticRenderFns } from "./InstructorProgramSnapshot.vue?vue&type=template&id=ef4056b4&scoped=true"
import script from "./InstructorProgramSnapshot.vue?vue&type=script&lang=js"
export * from "./InstructorProgramSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4056b4",
  null
  
)

export default component.exports